export const chainIdToHex = (chainId: number): string => {
  const hexString = chainId.toString(16);
  return "0x" + hexString;
};
